<!--
 * @FileDescription: 实时监控=》实时监控页面，某个头盔的历史记录视频组件
 -->
<template>
  <!--历史记录视频组件 -->
  <div class="video-play-main " v-if="videoShow" :style="external ? 'height: 100%' : ''">
    <div class="video-play-title">
      <i
        v-if="showBack"
        class="back-icon icon16"
        :class="isDefaultTheme ? 'back-light' : 'back-dark'"
        @click="returnList"
      ></i>
      <div class="name">
        <span :title="videoName">
          {{ videoName | ellipsis }}
        </span>
        <span class="fz12 time">
          {{ videoTime }}
        </span>
      </div>
      <el-popover placement="top" trigger="click">
        <table class="video-info-table">
          <tbody>
            <tr>
              <td class="video-info-td video-info-td100 video-info-title" colspan="2">
                {{ $t('VideoProperties') }}
              </td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('fileSizeH') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.fileSize }}MB</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('BitRate') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.videoBitRate }}kbps</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('Frames') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.videoFrameRate }}{{ $t('FramesSec') }}</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('widthH') }}</td>
              <td class="video-info-td video-info-td25">
                {{ videoInfo.videoWidth }}
              </td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('heightH') }}</td>
              <td class="video-info-td video-info-td25">
                {{ videoInfo.videoHeight }}
              </td>
            </tr>
          </tbody>
        </table>

        <i slot="reference" class="imp-icon icon20" @click="_videoInfo" v-show="!tabType"></i>
      </el-popover>
      <i class="last-icon icon20" @click="prevVideo" v-if="showPrevNext"></i>
      <i class="next-icon icon20" @click="nextVideo" v-if="showPrevNext"></i>
      <i class="speed-back-icon icon20" title="慢放" @click="changeSpeedLow"></i>
      <i class="speed-to-icon icon20" :title="$t('fastForward')" @click="changeSpeedHight"></i>
      <span>×</span>
      <span class="playbackRate">{{ playbackRate }}</span>
      <span class="turn-box">
        <i class="trans-icon" @click="turnAroundVideo"></i>
      </span>
      <div class="resolution" v-show="!tabType">
        <span
          :class="[isLowResolution ? 'resolution-low hightLight' : 'resolution-low']"
          @click="trggerResolution(true)"
          >{{ $t('fluent') }}</span
        >
        <span
          :class="[!isLowResolution ? 'resolution-hight hightLight' : 'resolution-hight']"
          @click="trggerResolution(false)"
          >{{ $t('highDefinition') }}</span
        >
      </div>
    </div>
    <div class="video-play-contain">
      <video
        :src="videoSrcPlay"
        autoplay="autoplay"
        :class="isZFY ? 'zfy-play' : turnAround ? 'handleVideo' : 'video-player'"
        :poster="posterPhotoUrl"
        id="history-video"
        @click.self="handlePlay"
        ref="videoBox"
      ></video>
      <div class="controls">
        <div class="play-info">
          <!-- 播放 -->
          <a class="switch fa fa-play">
            <!--播放按钮-->
            <img class="icon zanting" v-if="!showIcon" src="@/icon/real-video/video-play.png" alt="" />
            <!--暂停按钮-->
            <img class="icon bofang" v-else src="@/icon/real-video/video-pause.png" alt="" />
          </a>
          <div class="times">
            <span class="current">{{ nowTime }}</span> /
            <span class="totalTime">{{ allTimes }}</span>
          </div>
          <div class="expend fa fa-expand"  @mouseup="handleWidth" v-show="!external">
            <img class="icon" v-if="!reduce" src="@/icon/real-video/fullscreen.png" alt="" />
            <img class="icon reduce-icon" v-else src="@/icon/new-common/reduce.png" alt="" />
          </div>
          <div class="volume">
            <img class="icon volume-title" src="@/icon/new-command/vioce.png" alt="" />
            <input type="range" min="0" max="100" value="50" @change="setvalue()" id="ran" />
          </div>
        </div>
        <!-- 进度条 -->
        <div class="progress">
          <el-slider
            class="line-bar"
            v-model="pValue"
            :show-tooltip="false"
            @change="handleSpeed"
            @mousedown.native="handleline"
            @mouseup.native="handleUp"
          ></el-slider>
          <!-- <div class="progress-line"></div> -->
          <!-- <div class="bar"></div> -->
        </div>
      </div>
      <div v-if="videoSrcPlay === ''" class="play-tip">{{ playTip }}</div>
    </div>
  </div>
</template>

<script>
import { isImportantFlag, videoInfo } from '@/api/log/video'
import { success } from '@/api/common'
import { saveVideo } from '@/util/historyVideo'
import { saveFocusVideo } from '@/util/focusVideo'
import { mapGetters } from 'vuex'

export default {
  props: {
    videoSrcArr: {
      type: Array,
    },
    index: {
      type: Number,
    },
    videoShow: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    tabType: {
      type: String,
    },
    userData: {
      type: Object,
    },
    showPrevNext: {
      type: Boolean,
      default: true,
    },
    allowDrag: {
      type: Boolean,
      default: true,
    },
    external: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      nowTime: 0,
      allTimes: 0,
      isLowResolution: false,
      playbackRate: 1,
      playbackRateLevel: 1,
      // 拷贝后的index 用于修改下一个视频
      cpIndex: '',
      videoSrcArrCopy: '',
      videoSrcPlay: '',
      videoInfo: {
        fileSize: '',
        videoBitRate: '',
        videoFrameRate: '',
        videoWidth: '',
        videoHeight: '',
      },
      // 是否为天一执法仪
      isZFY: false,
      playTip: '',
      turnAround: false,
      timer: 0,
      pValue: 0,
      timeAdd: null,
      showIcon: false,
      videoLoadGif: require('@/icon/real-video/video-loding.gif'),
      posterPhotoUrl: require('@/icon/real-video/video-loding.gif'),
      handler: null,
      timeUp: null,
      handleTimer: null,
      reduce: false,
      rePlay: false,
      // 总的时间
      allDuration: 0,
      videos: [],
      playIdx: 0,
      //判断是否被拖动
      isChange: false,
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
    impFlag: {
      get() {
        if (this.videoSrcArrCopy[this.cpIndex]) {
          return this.videoSrcArrCopy[this.cpIndex].importantFlag
        } else {
          return ''
        }
      },
      set(newval) {
        let param = {
          importantFlag: newval,
          logTimestamp: this.videoSrcArrCopy[this.cpIndex].logTimestamp,
          type: 1,
          userId: this.videoSrcArrCopy[this.cpIndex].userId,
        }
        isImportantFlag(param).then(res => {
          if (res.state === 0) {
            success(this.$t('SettingSucceeded'))
            this.$emit('searchList')
          }
        })
      },
    },
    videoName() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        return this.videoSrcArrCopy[this.cpIndex].name
      } else {
        return ''
      }
    },
    videoTime() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        return this.videoSrcArrCopy[this.cpIndex].endTimestamp
      } else {
        return ''
      }
    },
    switchindex: function() {
      return this.index // 直接监听props里的status状态
    },
  },
  methods: {
    // 拖动进度条(鼠标按下)
    handleline() {
      // vue-draggable-resizable 拖动组件禁止拖动
      if(!this.reduce) {
        this.$emit('getAllow', false)
        this.isChange = true
      }
      
    },
    // 拖动进度条(鼠标抬起)
    handleUp() {
      if(!this.reduce) {
        this.$emit('getAllow', true)
        this.isChange = false
      }
    },
    turnAroundVideo() {
      this.turnAround = !this.turnAround
    },
    _videoInfo() {
      let val = this.videoName
      if (this.isLowResolution) {
        val = val.replace(/.mp4/, '.low.mp4')
      }
      this.videoInfo = {
        fileSize: '',
        videoBitRate: '',
        videoFrameRate: '',
        videoWidth: '',
        videoHeight: '',
      }
      let param = {
        fileName: val,
      }
      videoInfo(param).then(res => {
        if (res.state === 0) {
          this.videoInfo = res.value.videoInfo
          this.videoInfo.fileSize = (this.videoSrcArrCopy[this.index].size / 1024).toFixed(2)
        }
      })
    },
    returnList() {
      this.$emit('update:videoShow', false)
      this.playbackRate = 1
      // 解决刷新
      this.$emit('searchList')
    },
    // 切换分辨率
    trggerResolution(type) {
      this.isLowResolution = type
      this.handleVideo()
    },
    // 下一个视频
    nextVideo() {
      if (this.cpIndex >= this.videoSrcArrCopy.length - 1) {
        this.cpIndex = 0
      } else {
        this.cpIndex += 1
      }
      this.playbackRate = 1
    },
    // 上一个视频
    prevVideo() {
      if (this.cpIndex === 0) {
        this.cpIndex = this.videoSrcArrCopy.length - 1
      } else {
        this.cpIndex -= 1
      }
      this.playbackRate = 1
    },

    // 快进
    changeSpeedHight() {
      if (this.playbackRateLevel !== 5) {
        this.playbackRateLevel = this.playbackRateLevel + 1
      }
      switch (this.playbackRateLevel) {
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.videoBox.playbackRate = this.playbackRate
    },
    // 慢放
    changeSpeedLow() {
      if (this.playbackRateLevel !== 0) {
        this.playbackRateLevel = this.playbackRateLevel - 1
      }
      switch (this.playbackRateLevel) {
        case 0:
          this.playbackRate = 0.5
          break
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.videoBox.playbackRate = this.playbackRate
    },
    //退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.oCancelFullScreen) {
        document.oCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    //判断是否全屏
    isFullScreen() {
      return (
        document.fullscreen ||
        document.msFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreen ||
        document.oFullScreen ||
        document.webkitIsFullScreen
      )
    },
    setvalue() {
      let myvideo = document.getElementById('history-video')
      let ran = document.getElementById('ran')
      myvideo.volume = ran.value / 100
      myvideo.muted = false
    },
    // 自定义改变宽高

    handleWidth() {
      let pageWidth = document.documentElement.scrollWidth - 10
      let pageHeight = document.documentElement.scrollHeight - 90
      let that = this
      that.reduce = !that.reduce
      
      let amplifyVideo = document.getElementById('amplifyVideo')
      let focusVideo = document.getElementById('focusAmplifyVideo')
      if (amplifyVideo) {
        if (that.reduce) {
          // '99%' '92%'
          amplifyVideo.style.width = pageWidth
          amplifyVideo.style.height = pageHeight
          amplifyVideo.style.left = '0'
          amplifyVideo.style.top = '75px'
          this.$emit('getAllow', false,pageWidth,pageHeight,0,0)
          
        } else {
          amplifyVideo.style.width = '30%'
          amplifyVideo.style.height = '48%'
          amplifyVideo.style.left = '30%'
          amplifyVideo.style.top = '20%'
          this.$emit('getAllow', true,this.width,this.height)
        }
        return
      }

      if (focusVideo) {
        if (that.reduce) {
          focusVideo.style.width = '99%'
          focusVideo.style.height = '98%'
          focusVideo.style.left = '0.4%'
          focusVideo.style.top = '1%'
          focusVideo.style.position = 'fixed'
          focusVideo.style.zIndex = '9999999'
        } else {
          focusVideo.style.width = '99%'
          focusVideo.style.height = '375px'
          focusVideo.style.left = '2%'
          focusVideo.style.top = '2%'
          focusVideo.style.position = 'static'
        }
        return
      }
    },
    // 点击视频暂停播放
    handlePlay() {
      let that = this
      if (that.$refs.videoBox.paused) {
        that.$refs.videoBox.play()
        that.showIcon = true
      } else {
        that.$refs.videoBox.pause()
        that.showIcon = false
      }
    },
    // 拖动、/点击进度条
    handleSpeed(e) {
      let that = this
      let videospeed = document.getElementById('history-video')
      // that.pValue = e
      that.rePlay = false
      var time = that.allDuration * (e / 100)
      that.timer = time
      that.pValue = (that.timer / that.allDuration) * 100
      // $('.progress-line').css('width', that.pValue + '%')
      for (let i = 0; i < that.videos.length; i++) {
        let sumDuration = Math.floor(that.videos[i].lastDuration / 1000)
        if (time < sumDuration) {
          if (that.playIdx !== i) {
            that.playIdx = i
            that.posterPhotoUrl = that.videoLoadGif
            if (that.isLowResolution && that.videos[that.playIdx].mediaLowUrl) {
              videospeed.src = that.videos[that.playIdx].mediaLowUrl
            } else {
              videospeed.src = that.videos[that.playIdx].mediaUrl
            }
            videospeed.playbackRate = that.playbackRate
          }
          videospeed.currentTime = that.videos[i].duration / 1000 - (sumDuration - time)
          if (videospeed.paused) {
            videospeed.play()
            that.showIcon = true
          }
          return
        }
      }
    },
    // video 自定义控件
    handleVideo() {
      let that = this
      that.playIdx = 0
      that.timer = 0
      that.pValue = 0
      that.$refs.videoBox.removeEventListener('ended', that.handler)
      that.$refs.videoBox.removeEventListener('timeupdate', that.handleTimer)
      document.querySelector('.switch').removeEventListener('click', this.timeUp)
      that.nowTime = that.getTimeBySecond(that.timer)
      that.videos = []
      // 监控录制视频转换数据结构
      if (that.videoSrcArrCopy[that.cpIndex].videoTime) {
        that.videoSrcArrCopy[that.cpIndex]['groupVideoList'] = [
          {
            mediaUrl: that.videoSrcArrCopy[that.cpIndex].mediaUrl,
            mediaLowUrl: that.videoSrcArrCopy[that.cpIndex].mediaUrl,
            duration: Number(that.videoSrcArrCopy[that.cpIndex].videoTime) * 1000,
            lastDuration: Number(that.videoSrcArrCopy[that.cpIndex].videoTime) * 1000,
            logTimestamp: that.videoSrcArrCopy[that.cpIndex].startTime,
            endTimestamp: that.videoSrcArrCopy[that.cpIndex].endTime,
            name: that.videoSrcArrCopy[that.cpIndex].name,
          },
        ]
        that.videoSrcArrCopy[that.cpIndex]['uploadFlag'] = true
        that.videoSrcArrCopy[that.cpIndex]['status'] = 0
        that.videoSrcArrCopy[that.cpIndex]['duration'] = Number(that.videoSrcArrCopy[that.index].videoTime) * 1000
      }
      that.allDuration = Math.floor(that.videoSrcArrCopy[that.cpIndex].duration / 1000)
      let videoDom = document.getElementById('history-video')
      that.rePlay = false
      if (that.isLowResolution) {
        for (let i = 0; i < that.videoSrcArrCopy[that.cpIndex].groupVideoList.length; i++) {
          if (!that.videoSrcArrCopy[that.cpIndex].groupVideoList[i].mediaLowUrl) {
            that.videoSrcArrCopy[that.cpIndex].groupVideoList[i].mediaLowUrl =
              that.videoSrcArrCopy[that.cpIndex].groupVideoList[i].mediaUrl
          }
        }
      }
      that.videos = that.videoSrcArrCopy[that.cpIndex].groupVideoList
      if (that.videos[that.playIdx].mediaUrl) {
        if (that.videos[that.playIdx].preMediaUrl) {
          that.posterPhotoUrl = that.videos[that.playIdx].preMediaUrl
        } else {
          that.posterPhotoUrl = that.videoLoadGif
        }
        if (that.isLowResolution) {
          videoDom.src = that.videos[that.playIdx].mediaLowUrl
        } else {
          videoDom.src = that.videos[that.playIdx].mediaUrl
        }
        that.showIcon = true
        // 从指定秒数开始播放
        if (that.videoSrcArrCopy[that.cpIndex].featureVideoSeconds) {
          videoDom.currentTime = that.videoSrcArrCopy[that.cpIndex].featureVideoSeconds
        }
      } else {
        // 视频显示为未上传或以删除
        videoDom.src = ''
        videoDom.currentTime = 0
        that.allTimes = that.getTimeBySecond(0)
        // video 画面视频帧为loading
        that.posterPhotoUrl = that.videoLoadGif
      }
      let length = that.videos.length

      that.handler = function(event) {
        if (that.playIdx + 1 >= length) {
          that.rePlay = true
          videoDom.pause()
          that.showIcon = false
        } else {
          that.playIdx += 1
          if (that.videos[that.playIdx].preMediaUrl) {
            that.posterPhotoUrl = that.videos[that.playIdx].preMediaUrl
          } else {
            that.posterPhotoUrl = that.videoLoadGif
          }
          if (that.isLowResolution) {
            videoDom.src = that.videos[that.playIdx].mediaLowUrl
          } else {
            videoDom.src = that.videos[that.playIdx].mediaUrl
          }
          that.$refs.videoBox.playbackRate = that.playbackRate
          videoDom.play()
          that.showIcon = true
        }
      }
      videoDom.addEventListener('ended', that.handler)
      // $('video').css('height', videoHeight + 'px')

      //播放或暂停
      this.timeUp = function() {
        //判断当前视频是否暂停
        if (videoDom.paused) {
          if (that.rePlay) {
            that.playIdx = 0
            that.rePlay = false
            if (that.isLowResolution && that.videos[that.playIdx].mediaLowUrl) {
              videoDom.src = that.videos[that.playIdx].mediaLowUrl
            } else {
              videoDom.src = that.videos[that.playIdx].mediaUrl
            }
            that.$refs.videoBox.playbackRate = that.playbackRate
          }
          //播放
          videoDom.play()
          that.showIcon = true
        } else {
          that.showIcon = false
          videoDom.pause() //暂停
        }
      }
      document.querySelector('.switch').addEventListener('click', this.timeUp)

      that.handleTimer = function() {
        if (that.isChange === true) return
        //显示当前播放进度的时间
        if (videoDom.currentTime) {
          that.timer = Math.floor(
            (Number(that.videos[that.playIdx].lastDuration) -
              Number(that.videos[that.playIdx].duration) +
              videoDom.currentTime * 1000) /
              1000
          )
          //用秒数来显示当前播放进度
          that.nowTime = that.getTimeBySecond(that.timer)
          that.pValue = (that.timer / that.allDuration) * 100
          //更新进度条
          $('.progress-line').css('width', that.pValue + '%')
        }
      }
      videoDom.addEventListener('timeupdate', that.handleTimer)

      //当视频元数据加载时运行
      videoDom.addEventListener('loadedmetadata', function() {
        // 处理单个视频时候时长错误问题
        if (
          that.videos &&
          that.videos[that.playIdx] &&
          that.videos[that.playIdx].duration &&
          videoDom.duration &&
          that.videos[that.playIdx].duration !== videoDom.duration
        ) {
          that.allDuration = that.allDuration - that.videos[that.playIdx].duration / 1000 + videoDom.duration
        }
        //设置总时长
        that.allTimes = that.getTimeBySecond(that.allDuration)
      })
    },
    //讲当前秒数转换为时间
    getTimeBySecond(second) {
      var hour = parseInt(second / (60 * 60))
      var minute = parseInt((second / 60) % 60)
      var seconds = parseInt(second % 60)
      return (
        (hour < 10 ? '0' + hour : hour) +
        ':' +
        (minute < 10 ? '0' + minute : minute) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds)
      )
    },
  },
  watch: {
    videoSrcArr: {
      handler(newval, old) {
        this.videoSrcArrCopy = newval
      },
      immediate: true,
    },
    index: {
      handler(newval, old) {
        if (this.index !== null) {
          this.playbackRateLevel = 1
          this.allTimes = this.getTimeBySecond(0)
          this.cpIndex = this.index
          if (this.videoSrcArrCopy.length > 0) {
            // this.videoSrcPlay = this.videoSrcArrCopy[this.index].groupVideoList
            if (this.showBack) {
              saveFocusVideo(this.videoSrcArrCopy[this.index])
            } else if (this.userData.deviceName && this.videoSrcArrCopy[this.index]) {
              saveVideo(this.userData.deviceName, this.videoSrcArrCopy[this.index])
            }

            // 判断是执法仪 并且序列号含有‘0200’天一执法仪
            if (
              this.videoSrcArrCopy[this.index].helmetId.indexOf('ZFY0200') !== -1 &&
              this.videoSrcArrCopy[this.index].name.indexOf('cr_') !== -1
            ) {
              // 如果是执法仪，则顺时针旋转视频90度
              this.isZFY = true
            } else {
              this.isZFY = false
            }
            setTimeout(() => {
              this.handleVideo()
            }, 500)
          }
        }
      },
      immediate: true,
    },
    cpIndex() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        this.playbackRateLevel = 1
        if (this.showBack) {
          //  焦点关注储存
          saveFocusVideo(this.videoSrcArrCopy[this.cpIndex])
        } else if (this.userData.deviceName && this.videoSrcArrCopy[this.cpIndex]) {
          // 历史记录储存
          saveVideo(this.userData.deviceName, this.videoSrcArrCopy[this.cpIndex])
        }
        if (
          this.videoSrcArrCopy[this.cpIndex].helmetId.indexOf('ZFY0200') !== -1 &&
          this.videoSrcArrCopy[this.cpIndex].name.indexOf('cr_') !== -1
        ) {
          // 如果是执法仪，则顺时针旋转视频90度
          this.isZFY = true
        } else {
          this.isZFY = false
        }
        if (!this.videoSrcArrCopy[this.cpIndex].uploadFlag && this.tabType !== 'Recording') {
          this.playTip = this.$t('videoVotUploaded')
          this.$refs.videoBox.src = ''
        } else if (this.videoSrcArrCopy[this.cpIndex].status === 1) {
          this.playTip = this.$t('videoDeleted')
          this.$refs.videoBox.src = ''
        } else {
          this.playTip = ''
        }
        this.handleVideo()
      }
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
@import '~@/style/history-video.styl'

.video-play-main
  width 100%
  height calc(100% - 30px)
  background-color: #fff;
  .handleVideo
    width 100%
    // height 320px
    object-fit fill
    -webkit-transform rotate(-180deg)
  .noTurn
    -webkit-transform rotate(0deg)
  // 播放操作栏控制
  .handleVideo::-webkit-media-controls-enclosure
    -webkit-transform rotate(-180deg)
  .handleVideo::-webkit-media-controls-volume-control-container
    display none !important
  // 当前播放时间
  .handleVideo::-webkit-media-controls-current-time-display
    display block !important
  // 剩余时间
  .handleVideo::-webkit-media-controls-time-remaining-display
    display block !important
  .video-play-title
    display flex
    align-items center
    padding 8px 0px
    color: var(--black-color);
    border var(--table-border);
    :nth-child(2)
      margin-top: 2px
    .name
      display flex
      flex-direction column
      margin-left 15px
      color #333
      .time
        color var(--video-time-color)
    .importantCheck
      margin-right 10px
    .back-icon
      cursor pointer
      margin-left 10px
    .back-light
      bg-image('~@/icon/ic_back.png')
    .back-dark
      bg-image('~@/icon/ic_back_new.png')
    .imp-icon
      margin-left 20px
      margin-right 10px
      bg-image('~@/icon/imp.png')
    .last-icon
      cursor pointer
      bg-image('~@/icon/last_one.png')
      margin 0 5px
    .next-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/next_one.png')
    .turn-box
      position: relative
      display: inline-block
      width 20px
      height: 20px
      border 1px solid #0565de
      border-radius: 50%
      background: rgb(5, 101, 222)
      margin 0 5px
      .trans-icon
        position: absolute
        left 50%
        top 50%
        transform: translate(-50%,-50%)
        display: inline-block
        width 14px
        height: 14px
        cursor pointer
        bg-image('~@/icon/trans.png')
    .speed-to-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-to.png')
    .speed-back-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-back.png')
    .playbackRate
      min-width 20px
    .resolution
      margin-left 20px
      .resolution-low
        cursor pointer
        padding 2px 6px
        border-bottom-left-radius 8px
        border-top-left-radius 8px
        border 1px solid #D4D4D4
      .resolution-hight
        cursor pointer
        padding 2px 6px
        border 1px solid #D4D4D4
        border-bottom-right-radius 8px
        border-top-right-radius 8px
      .hightLight
        background var(--video-resolution-bg)
        color var(--hisvideo-resolution-color)
  .video-play-contain
    position relative
    width 100%
    height calc(100% - 60px)
    .video-player
      width 100%
      height 100%
      object-fit fill
    .zfy-play
      position absolute
      left 24%
      top 0
      width 46%
      height 100%
      object-fit fill
      -webkit-transform rotate(-90deg)
    .play-tip
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)
      color #fff
      font-weight 600
.video-info-table
  border-collapse collapse
  .video-info-td25
    width 25%
  .video-info-td100
    width 100%
  .video-info-title
    text-align center
    font-weight bold
  .video-info-td
    border 1px solid #000000
    padding 0 0 0 3px
// 播放操作栏控制
.zfy-play::-webkit-media-controls-enclosure
  -webkit-transform rotate(90deg)
.zfy-play::-webkit-media-controls-volume-control-container
  display none !important
// 当前播放时间
.zfy-play::-webkit-media-controls-current-time-display
  display block !important
// 剩余时间
.zfy-play::-webkit-media-controls-time-remaining-display
  display block !important

// 深色样式
.theme-dark
  .video-play-main
    background-color: #415a89;
  .video-play-title
    .name
      color #fff
</style>
